/**
 * Entscheidungslogik des Deinstallations-Dialogs, bewusst ohne DOM.
 *
 * Das Frontend-Vitest laeuft mit environment: 'node' — testbare Logik gehoert
 * deshalb hierher und nicht in die View. views/uninstall.ts haelt nur noch den
 * Zustand und zeichnet ihn.
 *
 * Die Regel: Ohne Haekchen verhaelt sich der Dialog wie bisher (ein Klick,
 * Soft-Disable). Mit Haekchen braucht es zwei Klicks, weil die Loeschung
 * unwiderruflich ist. Jede Aenderung am Haekchen entschaerft wieder.
 */
export interface UninstallState {
  purgeChecked: boolean;
  armed: boolean;
}

export type UninstallAction = 'uninstall' | 'purge-and-uninstall' | 'none';

export function createUninstallState(): UninstallState {
  return { purgeChecked: false, armed: false };
}

export function setPurgeChecked(s: UninstallState, checked: boolean): UninstallState {
  // armed faellt bei JEDER Aenderung zurueck — auch beim Wiederankreuzen.
  return { purgeChecked: checked, armed: false };
}

export function pressPrimary(s: UninstallState): { state: UninstallState; action: UninstallAction } {
  if (!s.purgeChecked) return { state: s, action: 'uninstall' };
  if (!s.armed) return { state: { ...s, armed: true }, action: 'none' };
  return { state: s, action: 'purge-and-uninstall' };
}

export function primaryLabel(s: UninstallState): string {
  if (!s.purgeChecked) return 'Deinstallieren';
  return s.armed ? 'Wirklich? Jetzt endgültig löschen' : 'Unwiderruflich löschen und deinstallieren';
}
